import { Button } from "@admin/components/atoms/Button";
import { Modal, ModalProps } from "@admin/components/atoms/Modal";
import { addShift, dateToISO,LocationUser } from "@enos-monorepo/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface StartQuickShiftModalProps extends ModalProps {
  locationUser?: LocationUser;
  locationId: string;
  companyId: string;
}
export function StartQuickShiftModal({
  locationUser,
  locationId,
  companyId,
  ...props
}: StartQuickShiftModalProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const addQuickShiftMutation = useMutation({
    mutationFn: addShift,
    onSuccess: () => {
      toast.success(t("shift.The shift has been started"));
      queryClient.invalidateQueries({ queryKey: ["shifts"] });
      props.onClose?.();
    },
    onError: () => {
      toast.error(t("shift.Unable to start the shift"));
    },
  });
  const onSubmit = () => {
    const payload = {
      companyId: companyId,
      companyLocationId: locationId ?? "",
      userId: locationUser?.userId ?? "",
      workStartDate: dateToISO(new Date()),
    };
    addQuickShiftMutation.mutate(payload);
  };
  return (
    <Modal
      title={t("shift.Start a Quick Shift for", {
        firstName: locationUser?.firstName,
        lastName: locationUser?.lastName,
      })}
      {...props}
      actionButtons={
        <>
          <Button variant="secondary" type="button" onClick={props?.onClose}>
            {t("common.Discard")}
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={addQuickShiftMutation.isPending}
            loading={addQuickShiftMutation.isPending}
            onClick={onSubmit}
          >
            {t("shift.Start Shift")}
          </Button>
        </>
      }
    >
      <form>
        <div>
          {t("shift.Start Quick Shift With Detail", {
            name:
              locationUser?.firstName && locationUser?.lastName
                ? `${locationUser?.firstName} ${locationUser?.lastName}`
                : "",
          })}
        </div>
      </form>
    </Modal>
  );
}
